import { getDB } from "./schema";
import type { ConversationTurn } from "@/stores/useAgentStore";

/**
 * Persist and retrieve conversation turns per session (run).
 */

export async function saveConversation(
  runId: string,
  turns: ConversationTurn[],
): Promise<void> {
  const db = await getDB();
  await db.put("conversations", {
    runId,
    turns: turns as unknown[],
    updatedAt: new Date().toISOString(),
  });
}

export async function getConversation(
  runId: string,
): Promise<ConversationTurn[] | null> {
  const db = await getDB();
  const record = await db.get("conversations", runId);
  return record ? (record.turns as ConversationTurn[]) : null;
}

export async function deleteConversation(runId: string): Promise<void> {
  const db = await getDB();
  await db.delete("conversations", runId);
}
